import { inject, Signal } from '@angular/core';

import { PaginationSdkParams } from '@connect-services/client/services/fetch-all.service';
import { TableService } from '@connect-services/client/services/table.service';
import { AbstractComponent } from '@connect-services/src/app/abstract.component';
import { PaginatorComponent } from '@connect-services/src/lib/components/paginator/paginator.component';
import { SortState } from '@connect-services/src/lib/components/table/table.component';
import { defaultPaginationParameters, OrderEnum, PaginationParameters } from '@shared/client/models/pagination.model';

export abstract class AbstractPaginatedComponent extends AbstractComponent {
    public paginationParameters: PaginationParameters = { ...defaultPaginationParameters };

    private readonly tableService = inject(TableService);

    protected abstract paginator: Signal<PaginatorComponent | undefined>;

    public onPaginationChange(page: number): void {
        const pageInformation: PaginationSdkParams = {
            page: page,
            take: this.paginationParameters.take,
        };

        this.paginationParameters = this.tableService.onPaginationChange(pageInformation, this.paginationParameters);
        this.loadBloc();
    }

    public onSortChange(sortState?: SortState): void {
        if (!sortState) {
            return;
        }

        sortState = {
            ...sortState,
            order: sortState.order ?? OrderEnum.ASC,
        };

        this.paginationParameters = this.tableService.onSortChange(sortState, this.paginationParameters);
        this.paginator()?.resetPaginator();
        this.loadBloc();
    }

    protected abstract loadBloc(): void;
}
